/*
 Created by CHT 2019/9/9 14:51
 */
import * as mqtt from 'mqtt'


function RySocket() {
  this.client = null
  this.url = null
  this.username = null
  this.password = null
  this.topicMap = new Map()
}

RySocket.prototype.init = async function () {
  if (this.client) return ''
  if (this.url && this.username && this.password) {
    this._connect()
    return ''
  } else {
    return Promise.all([
      RySocket.getUrl(),
      RySocket.getAccount()
    ]).then(([url, conf]) => {
      this.url = url
      this.username = conf.username
      this.password = conf.password
      this._connect()
      return ''
    })
  }
}
RySocket.prototype.end = function () {
  if (this.client) {
    this.client.end(true)
    this.client = null
    return true
  } else {
    return false
  }
}
RySocket.prototype.subscribe = function (topic, callback) {
  this.topicMap.set(topic, callback)
  if (this.client) this.client.subscribe(topic, {qos: 2})
}
RySocket.prototype.unsubscribe = function (topic) {
  if (this.topicMap.has(topic)) this.topicMap.delete(topic)
  if (this.client) this.client.unsubscribe(topic)
}
RySocket.prototype._connect = function () {
  this.client = mqtt.connect(this.url, {
    clientId: 'sryjs_' + Math.random().toString(16).substr(2, 8),
    username: this.username,
    password: this.password,
    reconnectPeriod: 2000
  })
  this.client.on('message', (topic, payload) => {
    if (payload) {
      const callback = this.topicMap.get(topic)
      // if (callback) callback(JSON.parse(decodeURIComponent(window.atob(payload))), payload)
      if (callback) callback(JSON.parse(this.base64Decode(payload)), payload)
    }
  })
}
RySocket.prototype.reset = function () {
  this.end()
  this.url = null
  this.username = null
  this.password = null
  return true
}
RySocket.getUrl = null
RySocket.getAccount = null

RySocket.MESSAGE_TYPE_IS_BINDING = 1000
RySocket.MESSAGE_TYPE_NOT_BIND = 1001
RySocket.MESSAGE_TYPE_REFRESH_DATA = 1200 // 刷新数据消息
RySocket.MESSAGE_TYPE_PLUGIN_RESULT = 1300 // 插件执行结果消息
RySocket.MESSAGE_TYPE_UPDATE_FORM = 1400 // 更新表单数据消息
RySocket.MESSAGE_TYPE_UPDATE_MIX_FORM = 1500 // 更新表单数据消息
RySocket.MESSAGE_TYPE_UPDATE_MIX_FORM_UPLOAD = 1501 // 项目扫码上传图片
RySocket.MESSAGE_TYPE_UPDATE_COMPANY = 1600 // 团队信息变更消息（app变化，组织架构变化）
RySocket.MESSAGE_TYPE_TASK = 1700 // 任务通知
RySocket.MESSAGE_TYPE_EXCEL_IMPORT_SUC = 1701 // 导入成功

RySocket.prototype.base64Decode = function (str) {
  return decodeURIComponent(atob(str).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));
}
export default RySocket


